import React, {FC} from 'react';
import PageHeader from "../tracing/PageHeader";
import {formatDate, limit} from "../../../utils/convert";
import PlusIcon from "../../common/icons/PlusIcon";
import {Link, useNavigate} from "react-router-dom";
import WikiIcon from "../../common/icons/WikiIcon";
import endpoints from "../../../endpoints";
import HistoryIcon from "../../common/icons/HistoryIcon";
import CloseIcon from "../../common/icons/CloseIcon";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setOptionsAction} from "../../../store/reducers/commonSlice";
import classNames from "classnames";
import ArrowDownIcon from "../../common/icons/ArrowDownIcon";
import ArrowUpIcon from "../../common/icons/ArrowUpIcon";
import {logAPI} from "../../../api/log";

const closeButtonClass = "ml-2 text-sm focus:outline-none text-white bg-red-300 hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-[50%] font-medium text-sm"
const thClass = "select-none border-b font-medium px-2 pt-3 pb-3 text-slate-800 text-left bg-gray-100";
const tdClass = "border-b border-slate-300 dark:border-slate-700 px-2 pt-2 pb-2 text-slate-500";
const tableClass = "border-collapse table-fixed w-full text-sm mt-3";


const LogsList = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const options = useAppSelector(state => state.common.options)

    const {data: logs} = logAPI.useGetAllQuery({
        sort: options.logsSortingField,
        order: options.logsSortingType as "desc" | "asc",
        tag: options.logsFilterTag,
        dateFrom: options.logsFilterDateFrom,
        dateTo: options.logsFilterDateTo,
    })

    return (
        <section className="mb-[15px]">
            <div className="container">
                <div className="flex flex-row justify-between">
                    <table className={tableClass}>
                        <thead>
                        <tr>
                            <TH title="Date" field="date" />
                            <TH title="Event" field="tag" />
                            <TH title="Comment" field="comment" />
                            <TH title="Data" />
                            <TH />
                        </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-slate-800 w-[30px] h-[30px]">
                        {logs && logs.map(log => <tr className="hover:bg-blue-100" key={log.id}>
                            <td className={tdClass}>{formatDate(log.date)}</td>
                            <td className={tdClass}>{log.tag}</td>
                            <td className={tdClass}>{log.comment}</td>
                            <td className={tdClass}><Data data={JSON.parse(log.data)} /></td>
                            <td width="150" className={`${tdClass} text-right`}>
                                {/*<div className="flex">*/}
                                {/*        <span className="inline-block cursor-pointer" onClick={() => loadStatistic(page)} >*/}
                                {/*            <PlusIcon width={32} height={32} />*/}
                                {/*        </span>*/}
                                {/*    <Link to={page.url} target="_blank" className="inline-block ml-2">*/}
                                {/*        <WikiIcon />*/}
                                {/*    </Link>*/}
                                {/*    <Link to={endpoints.editsHistoryUrl.replace('{title}', page.title)} target="_blank" className="inline-block ml-2">*/}
                                {/*        <HistoryIcon />*/}
                                {/*    </Link>*/}
                                {/*    <button className={closeButtonClass + ' ml-2'} onClick={() => deletePage(page.id)}>*/}
                                {/*        <CloseIcon width={34} height={30} />*/}
                                {/*    </button>*/}
                                {/*</div>*/}
                            </td>
                        </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};

const Data: FC<{data: any}> = ({data}) => {
    return <div>
        {!!data && Object.keys(data).map(key => <div className="whitespace-nowrap">
            <b>{key}: </b>
            <span>{data[key]}</span>
        </div>)}
    </div>
}

type TTHProps = {
    title?: string
    field?: string
}

const TH: FC<TTHProps> = ({title, field}) => {
    const dispatch = useAppDispatch()
    const options = useAppSelector(state => state.common.options)

    const changeSorting = (e: React.MouseEvent<HTMLSpanElement>) => {
        if (!field || !title) return;
        dispatch(setOptionsAction({
            logsSortingField: field,
            logsSortingType: options.logsSortingField === field ? (
                options.logsSortingType === 'asc' ? 'desc' : 'asc'
            ) : 'asc'
        }))
    }

    if (!field) {
        return <th className={`${thClass} w-[170px]`} >{title ?? ''}</th>;
    }

    return (
        <th className={thClass}>
            <div
                className={classNames('flex select-none', {'cursor-pointer': field && title})}
                data-field={field}
                onClick={changeSorting}
            >
                <span className="mr-2 select-none">{title}</span>
                {options.logsSortingField === field && (options.logsSortingType === 'desc' ? <ArrowDownIcon /> : <ArrowUpIcon />)}
            </div>
        </th>
    )
}

export default LogsList;